import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { selectUser } from "../auth/authSelectors";
import { getDefaultRouteByRole } from "../utils/roleRoute";

const normalize = (value) =>
  typeof value === "string" ? value.toLowerCase().trim() : null;

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const user = useSelector(selectUser);
  const location = useLocation();

  console.log("=== ProtectedRoute ===");
  console.log("Current URL:", location.pathname);
  console.log("User:", user);
  console.log("Allowed Roles:", allowedRoles);

  // 1️⃣ Not logged in
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const userRole = normalize(user.role);
  const defaultRoute = getDefaultRouteByRole(user.role);

  // Normalize allowed roles safely
  const normalizedAllowedRoles = allowedRoles
    .filter(r => typeof r === "string")
    .map(r => r.toLowerCase().trim());

  // 2️⃣ Role check
  if (
    normalizedAllowedRoles.length > 0 &&
    !normalizedAllowedRoles.includes(userRole)
  ) {
    console.log("Access denied → redirecting");
    return <Navigate to={defaultRoute} replace />;
  }

  return children;
};

export default ProtectedRoute;


// import { useSelector } from "react-redux";
// import { Navigate, useLocation } from "react-router-dom";
// import { selectUser } from "../auth/authSelectors";
// import { getDefaultRouteByRole } from "../utils/roleRoute";

// const ProtectedRoute = ({ children, allowedRoles }) => {
//   const user = useSelector(selectUser);
//   const location = useLocation();

//   console.log("=== ProtectedRoute ===");
//   console.log("Current URL:", location.pathname);
//   console.log("User from Redux:", user);
//   console.log("Allowed Roles for this route:", allowedRoles);

//   if (!user) {
//     console.log("User not logged in. Redirecting to /login");
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   const defaultRoute = getDefaultRouteByRole(user.role);
//   console.log("Default route for user:", defaultRoute);

//   // Manual URL tampering protection
//   if (!allowedRoles.includes(user.group_id)) {
//     console.log(
//       `User group_id (${user.group_id}) not allowed for this route. Redirecting to default route.`
//     );
//     return <Navigate to={defaultRoute} replace />;
//   }

//     if (
//     location.pathname === "/coach/template" &&
//     user.id !== 2
//   ) {
//     return <Navigate to={defaultRoute} replace />;
//   }

//   console.log("User allowed. Rendering page...");
//   return children;
// };

// export default ProtectedRoute;
